import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'通讯包类型',
            prop:'type',
            align:'center',
            headerAlign:'center',
            width:160,
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.TongxinType
                for(var i in list){
                   if(params.row.type*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'接收人2',
            prop:'receiverName',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            render: (h, params) => {
                let text = []
                let listName = params.row.receiverName.split(",")
                let listThone = params.row.receiverPhone.split(",") 
                for(var i in listName){
                    text.push(listName[i]+"-"+listThone[i])
                }
                return h('span',{},text.join(","))
            }
        },
        {
            label:'项目名称',
            prop:'projectName',
            align:'left',
            headerAlign:'left',
            tooltip:true,
        },
        {
            label:'数量',
            prop:'consumeCount',
            align:'center',
            headerAlign:'center',
            width:50,
            render: (h, params) => {
                return h('span',{},params.row.consumeCount+"条")
            }
        },
        {
            label:'消息内容',
            prop:'content',
            align:'left',
            headerAlign:'left',
            width:250,
            tooltip:true,
        },
        {
            label:'消费时间',
            prop:'sendTime',
            align:'left',
            width:160,
            headerAlign:'left',
            tooltip:true,
        }
    ]
}